const stripeEndpoint = '/api/health/api/stripe'

export type CheckoutItem = {
    documentId: string
}

export type CheckoutPayload = {
    items?: CheckoutItem[]
    bloodKitId?: string
    successUrl: string
    cancelUrl: string
}

const createCheckout = async (payload: CheckoutPayload, token: string) => {
    if (!token) throw new Error('No token provided')

    return await fetch(`${stripeEndpoint}/payments/checkout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
    })
}

// NOTE: Record a paid checkout when the buyer returns from Stripe
const confirmCheckout = async (sessionId: string, token: string) => {
    if (!sessionId) throw new Error('Invalid request')
    if (!token) throw new Error('No token provided')

    return await fetch(`${stripeEndpoint}/payments/confirm/${sessionId}`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export { createCheckout, confirmCheckout }
